"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import {
  APP_STATE_STORAGE_EVENT,
  getStoredState,
} from "@/services/stateStorage";
import { normalizeLocalState, type LocalState } from "@/utils/localState";

type DayKey =
  | "13-06"
  | "14-06"
  | "19-06"
  | "20-06"
  | "21-06"
  | "24-06"
  | "27-06"
  | "28-06"
  | "29-06"
  | "04-07"
  | "05-07"
  | "09-07"
  | "10-07"
  | "11-07"


type AttractionsByState = Record<LocalState, Partial<Record<DayKey, string[]>>>;

const ATTRACTIONS: AttractionsByState = {
  SP: {
    "13-06": [
      "/assets/atracoes/sp/13-06/1.png",
      "/assets/atracoes/sp/13-06/2.png",
      "/assets/atracoes/sp/13-06/3.png",
    ],
    "14-06": [
      "/assets/atracoes/sp/14-06/1.png",
      "/assets/atracoes/sp/14-06/2.png",
      "/assets/atracoes/sp/14-06/3.png",
    ],
    "19-06": [
      "/assets/atracoes/sp/19-06/1.png",
      "/assets/atracoes/sp/19-06/2.png",
      "/assets/atracoes/sp/19-06/3.png",
      "/assets/atracoes/sp/19-06/4.png",
    ],
    "20-06": [
      "/assets/atracoes/sp/20-06/1.png",
      "/assets/atracoes/sp/20-06/2.png",
      "/assets/atracoes/sp/20-06/3.png",
    ],
    "21-06": [
      "/assets/atracoes/sp/21-06/1.png",
      "/assets/atracoes/sp/21-06/2.png",
    ],
    "24-06": [
      "/assets/atracoes/sp/24-06/1.png",
      "/assets/atracoes/sp/24-06/2.png",
    ],
    "27-06": [
      "/assets/atracoes/sp/27-06/1.png",
      "/assets/atracoes/sp/27-06/2.png",
      "/assets/atracoes/sp/27-06/3.png",
    ],
    "28-06": [
      "/assets/atracoes/sp/28-06/1.png",
      "/assets/atracoes/sp/28-06/2.png",
      "/assets/atracoes/sp/28-06/3.png",
    ],
    "29-06": [
      "/assets/atracoes/sp/29-06/1.png",
      "/assets/atracoes/sp/29-06/2.png",
    ],
    "04-07": [
      "/assets/atracoes/sp/04-07/1.png",
      "/assets/atracoes/sp/04-07/2.png",
    ],
    "05-07": [
      "/assets/atracoes/sp/05-07/1.png",
      "/assets/atracoes/sp/05-07/2.png",
      "/assets/atracoes/sp/05-07/3.png",
    ],
    "09-07": [
      "/assets/atracoes/sp/09-07/1.png",
      "/assets/atracoes/sp/09-07/2.png",
    ],
    "10-07": [
      "/assets/atracoes/sp/10-07/1.png",
      "/assets/atracoes/sp/10-07/2.png",
    ],
    "11-07": [
      "/assets/atracoes/sp/11-07/1.png",
      "/assets/atracoes/sp/11-07/2.png",
    ],
  },
  RJ: {
    "13-06": [
      "/assets/atracoes/rj/13-06/1.png",
      "/assets/atracoes/rj/13-06/2.png",
      "/assets/atracoes/rj/13-06/3.png",
      "/assets/atracoes/rj/13-06/4.png",
      "/assets/atracoes/rj/13-06/5.png",
    ],
    "19-06": [
      "/assets/atracoes/rj/19-06/1.png",
      "/assets/atracoes/rj/19-06/2.png",
      "/assets/atracoes/rj/19-06/3.png",
      "/assets/atracoes/rj/19-06/4.png",
    ],
    "24-06": [
      "/assets/atracoes/rj/24-06/1.png",
      "/assets/atracoes/rj/24-06/2.png",
      "/assets/atracoes/rj/24-06/3.png",
    ],
    "29-06": [
      "/assets/atracoes/rj/29-06/1.png",
      "/assets/atracoes/rj/29-06/2.png",
      "/assets/atracoes/rj/29-06/3.png",
    ],
    "05-07": [
      "/assets/atracoes/rj/05-07/1.png",
      "/assets/atracoes/rj/05-07/2.png",
      "/assets/atracoes/rj/05-07/3.png",
    ],
    // "14-06": [
    //   "/assets/atracoes/rj/14-06/1.png",
    //   "/assets/atracoes/rj/14-06/2.png",
    //   "/assets/atracoes/rj/14-06/3.png",
    //   "/assets/atracoes/rj/14-06/4.png",
    // ],
  },
};

const DAY_OPTIONS: { key: DayKey; label: string }[] = [
  // { key: "13-06", label: "13/06" },
  // { key: "14-06", label: "14/06" },
  { key: "19-06", label: "19/06" },
  { key: "20-06", label: "20/06" },
  { key: "21-06", label: "21/06" },
  { key: "24-06", label: "24/06" },
  { key: "27-06", label: "27/06" },
  { key: "28-06", label: "28/06" },
  { key: "29-06", label: "29/06" },
  { key: "04-07", label: "04/07" },
  { key: "05-07", label: "05/07" },
  { key: "09-07", label: "09/07" },
  { key: "10-07", label: "10/07" },
  { key: "11-07", label: "11/07" },


];

const STATE_BACKGROUND: Record<LocalState, string> = {
  SP: "#158F0F",
  RJ: "#31B1E1",
};

function parseDayKey(dayKey: DayKey) {
  const [day, month] = dayKey.split("-").map(Number);
  return { day, month };
}

function getClosestAvailableDay(dayKeys: DayKey[], referenceDate = new Date()) {
  if (dayKeys.length === 0) {
    return "13-06" as DayKey;
  }

  const referenceTime = new Date(
    referenceDate.getFullYear(),
    referenceDate.getMonth(),
    referenceDate.getDate(),
  ).getTime();

  const datedDays = dayKeys
    .map((dayKey) => {
      const parsedDay = parseDayKey(dayKey);
      const time = new Date(
        referenceDate.getFullYear(),
        parsedDay.month - 1,
        parsedDay.day,
      ).getTime();

      return {
        dayKey,
        time,
      };
    })
    .sort((firstDay, secondDay) => firstDay.time - secondDay.time);

  const nextFutureOrToday = datedDays.find((day) => day.time >= referenceTime);

  if (nextFutureOrToday) {
    return nextFutureOrToday.dayKey;
  }

  return datedDays[datedDays.length - 1]?.dayKey ?? ("13-06" as DayKey);
}

function getCurrentState(): LocalState {
  return normalizeLocalState(getStoredState()) ?? "SP";
}

export default function ArtistasComponentPage() {
  const [selectedState, setSelectedState] =
    useState<LocalState>(getCurrentState);
  const [selectedDay, setSelectedDay] = useState<DayKey>(() =>
    getClosestAvailableDay(
      DAY_OPTIONS.filter(
        (day) => (ATTRACTIONS[getCurrentState()][day.key]?.length ?? 0) > 0,
      ).map((day) => day.key),
    ),
  );
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const syncState = () => {
      setSelectedState(getCurrentState());
    };

    window.addEventListener(
      APP_STATE_STORAGE_EVENT,
      syncState as EventListener,
    );
    window.addEventListener("storage", syncState);

    return () => {
      window.removeEventListener(
        APP_STATE_STORAGE_EVENT,
        syncState as EventListener,
      );
      window.removeEventListener("storage", syncState);
    };
  }, []);

  const availableDays = DAY_OPTIONS.filter(
    (day) => (ATTRACTIONS[selectedState][day.key]?.length ?? 0) > 0,
  );

  useEffect(() => {
    setSelectedDay(getClosestAvailableDay(availableDays.map((day) => day.key)));
    setSelectedIndex(0);
  }, [selectedState]);

  useEffect(() => {
    const availableDayKeys = availableDays.map((day) => day.key);

    if (!availableDayKeys.includes(selectedDay)) {
      setSelectedDay(getClosestAvailableDay(availableDayKeys));
      setSelectedIndex(0);
    }
  }, [availableDays, selectedDay]);

  const activeDay =
    availableDays.find((day) => day.key === selectedDay)?.key ??
    getClosestAvailableDay(availableDays.map((day) => day.key)) ??
    "13-06";
  const images = ATTRACTIONS[selectedState][activeDay] ?? [];
  const currentIndex = Math.min(selectedIndex, images.length - 1);
  const hasMultipleImages = images.length > 1;

  useEffect(() => {
    setSelectedIndex(0);
  }, [activeDay]);

  function goToPrevious() {
    setSelectedIndex((current) =>
      current === 0 ? images.length - 1 : current - 1,
    );
  }

  function goToNext() {
    setSelectedIndex((current) =>
      current === images.length - 1 ? 0 : current + 1,
    );
  }

  return (
    <section
      className="reveal-up px-6 py-10 md:px-10 md:py-14"
      style={{ backgroundColor: STATE_BACKGROUND[selectedState] }}
    >
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center">
        <div className="w-full max-w-[940px]">
          <h2
            className="text-[28px] font-black uppercase leading-none tracking-[-0.04em] text-[#2033EF]"
            style={{
              color: selectedState === "SP" ? "#FEC822" : "#2033EF",
            }}
          >
            Atrações
          </h2>
        </div>

        <div className="mt-8 flex flex-wrap w-full max-w-[860px] gap-4 overflow-x-auto pb-2 md:mt-10">
          {availableDays.map((day) => {
            const isActive = day.key === activeDay;

            return (
              <button
                key={day.key}
                type="button"
                onClick={() => {
                  setSelectedDay(day.key);
                  setSelectedIndex(0);
                }}
                className="min-w-[100px] cursor-pointer rounded-full border text-center text-[18px] font-black leading-none transition-colors md:min-w-[120px] p-2"
                style={{
                  backgroundColor: isActive ? "#FEC822" : "transparent",
                  borderColor: isActive ? "#FEC822" : "#FFFFFF",
                  color: isActive ? "#2033EF" : "#FFFFFF",
                }}
              >
                {day.label}
              </button>
            );
          })}
        </div>

        <div className="mt-10 flex w-full items-center justify-center md:mt-14">
          <div className="flex w-full max-w-[760px] items-center justify-center gap-3 md:max-w-[520px] md:gap-2">
            <button
              type="button"
              onClick={goToPrevious}
              aria-label="Ver atração anterior"
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-[30px] leading-none text-[#2033EF] shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-transform hover:scale-105 md:h-10 md:w-10"
            >
              <span aria-hidden="true">‹</span>
            </button>

            <div className="w-full max-w-[260px] md:max-w-[340px]">
              <div className="overflow-hidden">
                <Image
                  src={images[currentIndex]}
                  alt={`Atração ${currentIndex + 1} de ${images.length} em ${selectedState} no dia ${activeDay}`}
                  width={900}
                  height={1400}
                  priority
                  className="mx-auto h-auto w-full max-w-[400px] md:max-w-[320px]"
                />
              </div>
            </div>

            <button
              type="button"
              onClick={goToNext}
              aria-label="Ver próxima atração"
              // className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white text-[40px] leading-none text-[#2033EF] shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-transform hover:scale-105 md:h-18 md:w-18"
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-[30px] leading-none text-[#2033EF] shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-transform hover:scale-105 md:h-10 md:w-10"
              //
            >
              <span aria-hidden="true">›</span>
            </button>
          </div>
        </div>

        <div className="mt-8 flex items-center justify-center gap-3">
          {images.map((image, index) => {
            const isActive = index === currentIndex;

            return (
              <button
                key={image}
                type="button"
                aria-label={`Ir para atração ${index + 1}`}
                onClick={() => setSelectedIndex(index)}
                className="h-4 w-4 rounded-full transition-transform"
                style={{
                  backgroundColor: isActive ? "#7E826D" : "#E3E3E3",
                  transform: isActive ? "scale(1.05)" : "scale(1)",
                  opacity: hasMultipleImages ? 1 : 0.5,
                }}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
